const pinZoomParkAndPOIMaxCount = (zoomBucket: number): { maxNationalParks?: number; maxStateParks?: number; maxPOIs: number } => {
  switch (zoomBucket) {
    case 4:
      return { maxNationalParks: 0, maxStateParks: 0, maxPOIs: 0 };
    case 6:
      return { maxNationalParks: 0, maxStateParks: 0, maxPOIs: 0 };
    case 8:
      return { maxNationalParks: 3, maxStateParks: 0, maxPOIs: 0 };
    case 12:
      return { maxNationalParks: 5, maxStateParks: 0, maxPOIs: 3 };
    case 14:
      return { maxStateParks: 3, maxPOIs: 3 };
    default:
      return { maxPOIs: 5 };
  }
};

export default pinZoomParkAndPOIMaxCount;
